/**
 * IFRAME 容器页
 */
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import RichHeader from './RichHeader.jsx';
import MainFooter from '../../components/footers/Original_Main.jsx'
import SideBar from '../../components/affix/SideBar.jsx';
import { DOMAIN } from '../../constants/config'
import KeyBoard from '../../i/public/kb.png';
import VKeyboard from '../../components/tools/Virtual_Keyboard.jsx';

class ChangePassword extends React.Component {

  constructor(props) {
    super(props);

    // 如果没有修改密码的token
    if (!window.STORE.changePasswordToken) { window.location.href = '#/' }


    this.toggleVKeyBoard = this.toggleVKeyBoard.bind(this);
    this.toggleVKeyBoardRe = this.toggleVKeyBoardRe.bind(this);
    this.goLogin = this.goLogin.bind(this);
    this.verifyPwd = this.verifyPwd.bind(this);
    this.changePwd = this.changePwd.bind(this);
    this.reSetForm = this.reSetForm.bind(this);
    this.toggleTab = this.toggleTab.bind(this);
    this.state = {
      keyboardDispaly: false,//键盘1
      keyboardDispalyRe: false,//键盘2
      nowTab: 0
    }
  }

  // tab切换
  toggleTab() {
    this.setState({
      nowTab: 1 - this.state.nowTab
    })
  }

  // 打开虚拟键盘
  toggleVKeyBoard(display) {
    this.setState({
      keyboardDispaly: display || false,
      keyboardDispalyRe: false
    })
  }
  toggleVKeyBoardRe(display) {
    this.setState({
      keyboardDispalyRe: display || false,
      keyboardDispaly: false
    })
  }

  goLogin() {
    location.href = "#/login";
  }

  // 修改
  changePwd() {
    let pwd = ReactDOM.findDOMNode(this.refs.password).value,
      repwd = ReactDOM.findDOMNode(this.refs.password_re).value;

    // 验证是否相同
    if (pwd !== repwd) {
      this.props.$$BASE.openAlert('两次输入密码不相同');
      return;
    }

    // 验证格式
    if (!this.verifyPwd(pwd)) {
      this.props.$$BASE.openAlert('密码不符合规则，请重新输入');
      return;
    }

    this.props.$$USER.changePassword(pwd,repwd);
  }

  // 验证密码格式
  verifyPwd(pwd) {
    let patrn = /^[0-9a-zA-Z]{6,16}$/;
    if (!patrn.exec(pwd)) {
      return false;
    }
    patrn = /^\d+$/;
    if (patrn.exec(pwd)) {
      return false;
    }
    patrn = /^[a-zA-Z]+$/;
    if (patrn.exec(pwd)) {
      return false;
    }
    patrn = /(.)\1{2,}/;
    if (patrn.exec(pwd)) {
      return false;
    }
    return true;
  }


  // 重置
  reSetForm() {
    ReactDOM.findDOMNode(this.refs.password).value = '';
    ReactDOM.findDOMNode(this.refs.password_re).value = '';
    this.setState({
      random: _.random(999999)
    })
  }

  render() {
    const __base = this.props.__BASE.toJS();
    return (
      <div className={__base.ui.skin} >
        <div className='home-framework'>
          <VKeyboard display={this.state.keyboardDispaly} closeFun={this.toggleVKeyBoard.bind(this)} related='vkeyBorad' />
          <VKeyboard display={this.state.keyboardDispalyRe} closeFun={this.toggleVKeyBoardRe.bind(this)} related='vkeyBorad_re' />
          <RichHeader />
          <SideBar />
          <div className='pannel-content'>
            <div className="subContent_user_changepwd">
              <div>
                <div className="user_changepwd_tabs">
                  <ul className="changepwd_menus_ul">
                  <li className={this.state.nowTab == 0 ? 'on' : ''}>修改登录密码</li>
                  </ul>
                  {
                    this.state.nowTab == 0 ?
                      <div className="changepwd_tab_item">
                        <div className="anew_login_box">
                          <input type="button" value="重新登录" className="button_anew_login" onClick={this.goLogin} />
                        </div>
                        <table width="100%" cellSpacing="1" cellPadding="5">
                          <tbody>
                            <tr></tr>
                            <tr>
                              <td className="tdz3_left">请输入登录密码：</td>
                              <td className="tdz3_right">
                                <input type="password" className="passwordStyle keypad-cannot-close-handle" ref='password' id='vkeyBorad' />
                                <img src={KeyBoard} title="打开/关闭软键盘" className="keypad-trigger keypad-cannot-close-handle" onClick={this.toggleVKeyBoard.bind(this, true)} />
                                <span className="text_hint">由字母和数字组成6-16个字符</span>
                              </td>
                            </tr>
                            <tr>
                              <td className="tdz3_left">确认新登录密码：</td>
                              <td className="tdz3_right">
                                <input type="password" className="passwordStyle keypad-cannot-close-handle" ref='password_re' id='vkeyBorad_re' />
                                <img src={KeyBoard} title="打开/关闭软键盘" className="keypad-trigger keypad-cannot-close-handle" onClick={this.toggleVKeyBoardRe.bind(this, true)} />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div className="list_page">
                          <span className="font_red">备注：请妥善保管好您的登录密码，如遗忘请使用您的提款密码重置</span>
                        </div>
                        <div className="list_btn_box">
                          <input type="button" value="修改" className="formChange" onClick={this.changePwd.bind(this)} />
                          <input type="reset" value="重置" className="formReset" onClick={this.reSetForm.bind(this)} />
                        </div>
                      </div>
                      : null
                  }
                  {
                    this.state.nowTab == 1 ?
                      <div className="changepwd_tab_item">
                        <div className="list_page">
                          <span className="font_red">备注：请妥善保管好您的提款密码，如遗忘请使用密保功能找回或联系在线客服处理</span>
                        </div>
                      </div>
                      : null
                  }
                </div>
              </div>
            </div>
          </div>
          <MainFooter />
        </div>
      </div>
    );

  }
}

reactMixin(ChangePassword.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$USER: bindActionCreators(userAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangePassword)